
export const WORST_REACH_CHART_OPTIONS = {
    chart: {
        type: 'bar',
        dropShadow: { enabled: false },
        toolbar: { show: false }
    },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: '#000000',
            fontSize: '14px'
        }
    },
    plotOptions: {
        bar: {
            borderRadius: 0,
            horizontal: true,
            isFunnel: true,
            distributed: true,
            barHeight: '100%',
            funnelAlign: 'center'
        }
    },
    colors: ['#C25DB0', '#D78BC3', '#E6A7D6', '#F3C2E4', '#FAD9F0'],
    dataLabels: { enabled: false },
    xaxis: { categories: [] },
    yaxis: { show: false },
    tooltip: { enabled: true },
    legend: {
        show: true,
        position: 'left'
    }
};